export default {
  trails: state => state.trails, // array
  selected: state => state.selected, // object
  showTrailLabels: state => state.showTrailLabels // boolean
}
